function shouldShowModelSelectionButton(viewer) {
  if (!viewer) {
    return false
  }

  const isUnpublished = String(viewer.status) !== '1'
  const isTigerModel = String(viewer.modelOwnership || '').trim().toLowerCase() === 'tiger'

  return !(isUnpublished && !isTigerModel)
}

module.exports = {
  shouldShowModelSelectionButton
}
